export default "__VITE_ASSET__2a31a9eb__"